import CardProject from '../../components/items/CardProject'

import cineflix from '../../img/projects/cineFlix.png'
import react from '../../img/technology/react.png'
import html from '../../img/technology/html.png'
import css from '../../img/technology/css.png'
import javaScript from '../../img/technology/javascript.png'

export default function Project1() {
  return (
    <div>
      <CardProject
        name="Cineflix"
        img={cineflix}
        text="Este projeto é um layout front-end desenvolvido para uma aplicação que consome a API The Movie DB. Utilizando tecnologias modernas como ReactJS e CSS Modules, o projeto visa fornecer uma experiência de usuário otimizada e responsiva. Além disso, integra bibliotecas populares como React Router e React Icons para garantir uma navegação suave e uma interface visualmente atraente. O objetivo principal é criar uma interface intuitiva e eficiente para os usuários explorarem e descobrirem conteúdos cinematográficos de forma fácil e agradável."
        app="https://cine-flix-pied.vercel.app/"
        technology1={react}
        nameTechnology1="React JS"
        technology2={html}
        nameTechnology2="HTML"
        technology3={css}
        nameTechnology3="CSS"
        technology4={javaScript}
        nameTechnology4="JavaScript"
      />
    </div>
  )
}
